import { render, staticRenderFns } from "./errorStep.vue?vue&type=template&id=47b60f75&scoped=true"
import script from "./errorStep.vue?vue&type=script&lang=js"
export * from "./errorStep.vue?vue&type=script&lang=js"
import style0 from "./errorStep.vue?vue&type=style&index=0&id=47b60f75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b60f75",
  null
  
)

export default component.exports